import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IType from '../interfaces/IType';
import Layout from '~/components/Layout';


export default function Create() {  
  const {register, handleSubmit, control, setValue:setFormValue} = useForm<IType>();
  const fields = [
      { name: 'name', type: 'string'},
      { name: 'acronym', type: 'string'},
      { name: 'mask', type: 'string'},
  ];

    return(
      <Layout marginLayout={true}>
        <CrudCreate model={'dispatch/code'} 
          fields={fields} 
          register={register} 
          handleSubmit={handleSubmit} 
          control={control} 
          messageSuccess={'Dispatch Code successfully created!'}  
          title={'Add Dispatch Code'}  
          subheader={'Add Dispatch Code'}
          setFormValue={setFormValue} 
        />
      </Layout>
    )
}
